import React from 'react';
import { ChevronDown } from 'lucide-react';
import auditbuddyLogo from '../assets/auditbuddy-logo.svg';
import { MONTH_OPTIONS } from '../constants/monthConfig';
import DomainSelector from './DomainSelector';

export default function Header({ selectedMonth, onMonthChange, onSignOut, activeDomain, onDomainChange }) {
  return (
    <header className="sticky top-0 z-50 border-b border-app-border/80 bg-white/80 backdrop-blur-lg supports-[backdrop-filter]:bg-white/70">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <div className="flex items-center">
          <img
            src={auditbuddyLogo}
            alt="AuditBuddy"
            className="h-8 w-auto sm:h-9"
          />
        </div>

        {activeDomain && onDomainChange ? (
          <DomainSelector activeDomain={activeDomain} onDomainChange={onDomainChange} />
        ) : null}

        <div className="flex items-center gap-3">
          <label className="sr-only" htmlFor="dashboard-month-selector">Reporting month</label>
          <div className="relative">
            <select
              id="dashboard-month-selector"
              value={selectedMonth}
              onChange={(event) => onMonthChange(event.target.value)}
              className="h-10 appearance-none rounded-xl border border-app-border bg-white px-3 py-2 pr-9 text-[12px] font-semibold tracking-[0.06em] text-slate-600 shadow-sm outline-none transition duration-150 focus:border-sky-300 focus:ring-2 focus:ring-sky-100"
            >
              {MONTH_OPTIONS.map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
            <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          </div>

          <button
            type="button"
            onClick={onSignOut}
            className="text-[11px] font-medium uppercase tracking-[0.08em] text-slate-400 transition duration-200 hover:text-slate-600"
          >
            Sign Out
          </button>
        </div>
      </div>
    </header>
  );
}
